import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "charts-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { title: "火山警戒级别分布" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chart, {
                  class: "chart",
                  option: _ctx.alertLevelOption,
                  autoresize: ""
                }, null, 8, ["option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { title: "航空代码分布" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chart, {
                  class: "chart",
                  option: _ctx.aviationCodeOption,
                  autoresize: ""
                }, null, 8, ["option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, {
      gutter: 16,
      style: {"margin-top":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { title: "火山活动趋势" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chart, {
                  class: "chart",
                  option: _ctx.activityTrendOption,
                  autoresize: ""
                }, null, 8, ["option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}